import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import { formatDateTime, formatBattleName, formatDuration } from '../utils';

export default function Disconnects() {
  const [data, setData]     = useState(null);
  const [filter, setFilter] = useState('');
  const [limit, setLimit]   = useState(50);
  const [error, setError]   = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.disconnects(limit)
      .then(setData)
      .catch(e => setError(e.message));
  }, [limit]);

  if (error)  return <div className="page"><div className="error-box">{error}</div></div>;
  if (!data)  return <div className="page-center"><div className="spinner" /></div>;

  const active   = data.filter(d => !d.endTime);
  const resolved = data.filter(d =>  d.endTime);
  const q        = filter.toLowerCase();
  const list     = data.filter(d =>
    !q ||
    d.username?.toLowerCase().includes(q) ||
    d.clanName?.toLowerCase().includes(q) ||
    d.battleName?.toLowerCase().includes(q)
  );

  return (
    <div className="page fade-in">
      <div className="page-header">
        <div>
          <div className="page-header-title">Disconnect Log</div>
          <div className="page-header-sub">Player disconnects during clan battles</div>
        </div>
      </div>

      {/* Summary */}
      <div className="stats-row mb-20">
        <div className="stat-card">
          <div className="stat-val">{data.length}</div>
          <div className="stat-lbl">Total Events</div>
        </div>
        <div className="stat-card">
          <div className="stat-val text-red">{active.length}</div>
          <div className="stat-lbl">Currently Down</div>
        </div>
        <div className="stat-card">
          <div className="stat-val text-green">{resolved.length}</div>
          <div className="stat-lbl">Resolved</div>
        </div>
        {resolved.length > 0 && (
          <div className="stat-card">
            <div className="stat-val">
              {Math.round(resolved.reduce((s, d) => s + Number(d.durationMinutes || 0), 0) / resolved.length)}m
            </div>
            <div className="stat-lbl">Avg Duration</div>
          </div>
        )}
      </div>

      <div className="filter-bar">
        <input
          className="filter-input"
          placeholder="Filter by player, clan, or battle…"
          value={filter}
          onChange={e => setFilter(e.target.value)}
        />
        <select value={limit} onChange={e => setLimit(Number(e.target.value))}>
          <option value={50}>Last 50</option>
          <option value={100}>Last 100</option>
          <option value={200}>Last 200</option>
        </select>
      </div>

      {list.length === 0 && <div className="empty-msg">No disconnects match your filter.</div>}

      {list.length > 0 && (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Player</th>
                <th>Clan</th>
                <th>Battle</th>
                <th>Start</th>
                <th>Duration</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {list.map((d, i) => (
                <tr key={i}>
                  <td>
                    <button
                      style={{ background: 'none', border: 'none', color: 'var(--blue)', cursor: 'pointer', fontWeight: 600, fontSize: '.88rem' }}
                      onClick={() => navigate(`/player/${d.robloxId}`)}
                    >
                      {d.username}
                    </button>
                  </td>
                  <td style={{ color: 'var(--muted)', fontSize: '.85rem' }}>{d.clanName || '—'}</td>
                  <td>
                    <button
                      style={{ background: 'none', border: 'none', color: 'var(--blue)', cursor: 'pointer', fontSize: '.85rem' }}
                      onClick={() => navigate(`/battle/${d.battleId}`)}
                    >
                      {formatBattleName(d.battleName)}
                    </button>
                  </td>
                  <td style={{ color: 'var(--muted)', fontSize: '.83rem' }}>{formatDateTime(d.startTime)}</td>
                  <td style={{ fontSize: '.85rem' }}>
                    {d.durationMinutes != null ? formatDuration(d.durationMinutes) : '—'}
                  </td>
                  <td>
                    {d.endTime
                      ? <span className="badge badge-done">Resolved</span>
                      : <span className="badge badge-live">Active</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
